/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryCreatePayloadRequest
 */
export interface CategoryCreatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryCreatePayloadRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreatePayloadRequest
     */
    description: string;
}

/**
 * Check if a given object implements the CategoryCreatePayloadRequest interface.
 */
export function instanceOfCategoryCreatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function CategoryCreatePayloadRequestFromJSON(json: any): CategoryCreatePayloadRequest {
    return CategoryCreatePayloadRequestFromJSONTyped(json, false);
}

export function CategoryCreatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryCreatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
    };
}

export function CategoryCreatePayloadRequestToJSON(value?: CategoryCreatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

